import { render } from "./ListView.vue?vue&type=template&id=4c887c75&ts=true"
import script from "./ListView.vue?vue&type=script&lang=ts"
export * from "./ListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__